/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：コンフィグレーション
 *
 * 作成者：2021/11/19 ノア）黄
 * 最終修正者：2021/11/19 ノア）黄
 *
 */

// 共通APIbase url
const commonEnterPoint = 'common'
// マスタAPIbase url
const masterEnterPoint = 'master'
// 移動実績APIbase url
const perfEnterPoint = 'op/perf'
// 動態管理APIbase url
const dynamicEnterPoint = 'dynamic'
// 管理対象一覧APIbase url
const managementEnterPoint = 'management'
// Sigfoxクラウド連携APIbase url
// const sigfoxEnterPoint = 'sigfox'
// 会社登録ツールAPIbase url
const companyAddToolEnterPoint = 'system'

/**
 * コンフィグレーション
 *
 * @constant
 */
const config: Record<string, Record<string, string>> = {
  /**
   * API
   */
  api: {
    baseUrl: `${process.env.VUE_APP_API_SERVER}${process.env.VUE_APP_API_ENTER_POINT}${process.env.VUE_APP_API_VERSION}`,
    // ========================================= common =========================================
    // ログインする
    login: `/${commonEnterPoint}/login`,
    // MFA検証
    verification: `/${commonEnterPoint}/mfa/verification`,
    // MFA認証スイッチ
    mfaSwitch: `/${commonEnterPoint}/mfa/switch`,
    // MFA情報取得
    getMFAInfo: `/${commonEnterPoint}/mfa/info`,
    // ログインする
    logout: `/${commonEnterPoint}/logout`,
    // 編集画面ロック解除
    unlock: `/${commonEnterPoint}/unlock`,
    // 編集画面ロック
    lock: `/${commonEnterPoint}/lock`,
    // 編集画面ロックチェック
    checklock: `/${commonEnterPoint}/lock/check`,
    // 汎用定義を取得する
    getGeneralData: `/${commonEnterPoint}/general`,
    // お気に入りを取得する
    getFavMenuData: `/${commonEnterPoint}/bookmarks/list`,
    // お気に入りを更新する
    updateFavMenuData: `/${commonEnterPoint}/bookmarks/upsert`,
    // パスワードを変更する
    updatePassword: `/${commonEnterPoint}/password/update`,
    // 通話リクエスト実行
    updateCallerData: `/${commonEnterPoint}/caller/update`,
    // 連絡先情報取得
    getCallerData: `/${commonEnterPoint}/caller/info`,
    // 通知一覧取得する
    getNotificationsData: `/${commonEnterPoint}/notification/list`,
    // 通知更新
    updateNotificationsData: `/${commonEnterPoint}/notification/update`,
    // メッセージ一覧取得
    getMessageData: `/${commonEnterPoint}/message/list`,
    // メッセージ更新
    updateMessageData: `/${commonEnterPoint}/message/update`,
    // メッセージ登録
    messageSend: `/${commonEnterPoint}/message/send`,
    // メッセージ削除
    messageDelete: `/${commonEnterPoint}/message/delete`,
    // メッセージ送信履歴一覧取得
    getMessageSendList: `/${commonEnterPoint}/message/send/list`,
    // アナウンス一覧取得する
    getAnnounceData: `/${commonEnterPoint}/announce/list`,
    // アナウンス更新
    updateAnnounceData: `/${commonEnterPoint}/announce/update`,
    // アナウンス登録
    announceSend: `/${commonEnterPoint}/announce/send`,
    // 営業所所属ユーザ一覧取得
    getUserDataWithBusinessOffice: `/${commonEnterPoint}/user/list`,
    // MQTTコンフィグ取得
    getMQTTConfig: `/${commonEnterPoint}/config/mqtt`,
    // トークン時間更新
    refreshToken: `/${commonEnterPoint}/refresh/token`,

    // ========================================= master =========================================
    // テンプレートダウンロード
    templateDownload: `/${masterEnterPoint}/template/download`,
    // 会社管理情報保存
    updateCorporateMasterData: `/${masterEnterPoint}/company/update`,
    // 会社管理情報取得
    getCorporateMasterData: `/${masterEnterPoint}/company/info`,
    // ユーザ一覧取得
    getUserMasterData: `/${masterEnterPoint}/user/list`,
    // ユーザ保存
    updateUserMasterData: `/${masterEnterPoint}/user/upsert`,
    // 営業所一覧取得
    getBusinessOfficeMasterData: `${masterEnterPoint}/business/office/list`,
    // 営業所保存
    updateBusinessOfficeMaster: `/${masterEnterPoint}/business/office/upsert`,
    // 営業所一覧CSVダウンロード
    businessOfficeMasterDownload: `/${masterEnterPoint}/business/office/download`,
    // 営業所割当取得
    getSalesOfficeAllocationMasterData: `/${masterEnterPoint}/business/office/alloc/list`,
    // 営業所割当取得
    getSalesOfficeAllocationData: `/${masterEnterPoint}/business/office/user/alloc/list`,
    // 営業所割当保存
    updateSalesOfficeAllocationMasterData: `/${masterEnterPoint}/business/office/alloc/upsert`,
    // エリア一覧取得
    getAreaMasterData: `/${masterEnterPoint}/area/list`,
    // エリア保存
    updateAreaMasterData: `/${masterEnterPoint}/area/upsert`,
    // 端末設定情報取得
    getGpsTrackerTerminalConfigData: `/${masterEnterPoint}/device/info`,
    // 端末設定情報保存
    updateGpsTrackerTerminalConfigData: `/${masterEnterPoint}/device/upsert`,
    // クラウドアプリ制御設定値一覧取得
    getDeviceCloudSettingList: `/${masterEnterPoint}/device/cloud/setting/list`,
    // 都道府県割当一覧取得
    getAreaAllocationMasterData: `/${masterEnterPoint}/prefecture/alloc/list`,
    // 下位都道府県ありエリア一覧取得
    getAreaMasterDataWhoHasSubPrefecture: `/${masterEnterPoint}/area/alloc/list`,
    // 都道府県割当保存
    updateAreaAllocationMasterData: `/${masterEnterPoint}/prefecture/alloc/upsert`,
    // GPSトラッカー一覧取得
    getGpsTrackerMasterData: `/${masterEnterPoint}/tracker/list`,
    // GPSトラッカー保存
    updateGpsTrackerMasterData: `/${masterEnterPoint}/tracker/upsert`,
    // GPSトラッカー一覧CSVダウンロード
    gpsTrackerMasterDownload: `/${masterEnterPoint}/tracker/download`,
    // 受信回数カウント日別CSVダウンロード
    gpsTrackerDateCounCSVDownload: `/${masterEnterPoint}/tracker/date/count/download`,
    // 受信回数カウント月別CSVダウンロード
    gpsTrackerMonthCounCSVDownload: `/${masterEnterPoint}/tracker/month/count/download`,
    // トラクターヘッドを取得する
    getTractorHeadMasterData: `/${masterEnterPoint}/tractor/head/list`,
    // トラクターヘッドを更新する
    updateTractorHeadMasterData: `/${masterEnterPoint}/tractor/head/upsert`,
    // トラクターヘッド一覧CSVダウンロード
    tractorHeadMasterDownload: `/${masterEnterPoint}/tractor/head/download`,
    // 連結可能トラクターヘッドマスタを取得する
    getAvlTractorHeadMasterData: `/${masterEnterPoint}/avl/tractor/head/list`,
    // 連結可能トラクターヘッドマスタを更新する
    updateAvlTractorHeadMasterData: `/${masterEnterPoint}/avl/tractor/head/upsert`,
    // 連結可能トラクターヘッドマスタCSVダウンロード
    avlTractorHeadCSVDownload: `/${masterEnterPoint}/avl/tractor/head/download`,
    // 管理対象マスタを取得する
    getManagementTargetMasterData: `/${masterEnterPoint}/management/target/list`,
    // 管理対象を更新する
    updateManagementTargetMasterData: `/${masterEnterPoint}/management/target/upsert`,
    // 管理対象CSVダウンロード
    managementTargetCSVDownload: `/${masterEnterPoint}/management/target/download`,
    // 管理対象割当一覧取得
    getManagementTargetAllocMasterData: `/${masterEnterPoint}/management/target/alloc/list`,
    // 管理対象割当一覧取得
    updateManagementTargetAllocMasterData: `/${masterEnterPoint}/management/target/alloc/upsert`,
    // 管理場所を取得する
    getManagementPlaceMasterData: `/${masterEnterPoint}/place/list`,
    // 管理場所を取得する(MAP)
    getManagementPlaceMapData: `/${masterEnterPoint}/place/map/list`,
    // 管理場所を更新する
    updateManagementPlaceMasterData: `/${masterEnterPoint}/place/upsert`,
    // 管理場所CSVダウンロード
    managementPlaceCSVDownload: `/${masterEnterPoint}/place/download`,
    // 管理場所詳細を取得する
    getManagementPlaceDetailMasterData: `/${masterEnterPoint}/place/dtl/list`,
    // 管理場所詳細を取得する(MAP)
    getManagementPlaceDetailMapData: `/${masterEnterPoint}/place/dtl/map/list`,
    // 管理場所詳細を更新する
    updateManagementPlaceDetailMasterData: `/${masterEnterPoint}/place/dtl/upsert`,
    // 管理場所詳細CSVダウンロード
    managementPlaceDetailCSVDownload: `/${masterEnterPoint}/place/dtl/download`,
    // 管理場所画像アップロード
    uploadPlaceImgData: `/${masterEnterPoint}/place/img/upload`,
    // 管理場所詳細画像アップロード
    uploadPlaceDtlImgData: `/${masterEnterPoint}/place/dtl/img/upload`,
    // 認証済み画像URL取得
    getPlaceImage: `/${masterEnterPoint}/place/image/get`,
    // バッテリー交換
    trackerExchange: `/${masterEnterPoint}/tracker/exchange`,
    // GPSトラッカー詳細取得
    getTrackerDetail: `/${masterEnterPoint}/tracker/detail`,
    // デジタコ連携会社保存
    updateConnectCompanyMasterData: `/${masterEnterPoint}/connect/company/upsert`,
    // デジタコ連携会社一覧取得
    getConnectCompanyMasterData: `/${masterEnterPoint}/connect/company/list`,
    // デジタコ連携会社一覧CSVダウンロード
    connectCompanyMasterCsvDownload: `/${masterEnterPoint}/connect/company/download`,

    // ========================================= op/perf =========================================
    // 移動履歴管理表指示日時管理CSVダウンロード
    opPerfIndicateDateCSVDownload: `/${perfEnterPoint}/mvmt/indicate/csv/download`,
    // 移動履歴管理表指示日時管理PDFダウンロード
    opPerfIndicateDatePDFDownload: `/${perfEnterPoint}/mvmt/indicate/pdf/download`,
    // 移動履歴管理表一定期間停止管理CSVダウンロード
    opPerfMvmtCSVDownload: `/${perfEnterPoint}/mvmt/csv/download`,
    // 移動履歴管理表一定期間停止管理PDFダウンロード
    opPerfMvmtPDFDownload: `/${perfEnterPoint}/mvmt/pdf/download`,
    // 営業所別分析CSVダウンロード
    opPerfOfcCSVDownload: `/${perfEnterPoint}/ofc/csv/download`,
    // 営業所別分析PDFダウンロード
    opPerfOfcPDFDownload: `/${perfEnterPoint}/ofc/pdf/download`,
    // エリア別分析結果取得
    opPerfArea: `/${perfEnterPoint}/area`,
    // エリア別分析PDFダウンロード
    opPerfAreaPDFDownload: `/${perfEnterPoint}/area/graph/download`,
    // 都道府県別分析結果取得
    opPerfAreaPrefecture: `/${perfEnterPoint}/area/prefecture`,
    // 都道府県別分析PDFダウンロード
    opPerfPrefecturePDFDownload: `/${perfEnterPoint}/area/prefecture/graph/download`,
    // 都道府県別分析CSVダウンロード
    opPerfPrefectureCSVDownload: `/${perfEnterPoint}/area/prefecture/csv/download`,
    // 都道府県別分析移動履歴一覧取得
    managementObjectAnalysisData: `/${perfEnterPoint}/area/prefecture/history/list`,
    // エリア別分析移動履歴CSVダウンロード
    opPerfAreaManageCSVDownload: `/${perfEnterPoint}/area/csv/download`,
    // エリア別分析移動履歴PDFダウンロード
    opPerfAreaManagePDFDownload: `/${perfEnterPoint}/area/pdf/download`,

    // ========================================= dynamic =========================================
    // 動態管理対象一覧を取得する
    getDynamicTargetData: `/${dynamicEnterPoint}/target/list`,
    // 移動履歴一覧取得する
    getDynamicHistoryData: `/${dynamicEnterPoint}/history/list`,
    // 動態管理対象マスタを取得する
    getDynamicTargetMasterData: `/${dynamicEnterPoint}/target/simplified/list`,

    // ========================================= management =========================================
    // 管理対象一覧を取得する
    getManagementTargetData: `/${managementEnterPoint}/target/list`,
    // 管理対象一覧ダウンロード
    managementTargetDataDownload: `/${managementEnterPoint}/target/download`,
    // 管理対象一覧ダウンロード
    managementTargetHistoryDownload: `/${managementEnterPoint}/target/history/download`,
    // 受信回数アラートリスト
    getAlertListData: `/${managementEnterPoint}/target/alert/list`,

    // ========================================= alarm =========================================
    // アラーム一覧を取得する TODO
    getAlarmData: `/${managementEnterPoint}/alarm`,

    // ========================================= system =========================================
    // 会社一覧を取得する
    getCompanyInfoListData: `/${companyAddToolEnterPoint}/company/list`,
    // 会社情報新規登録
    addCompanyInfo: `/${companyAddToolEnterPoint}/company/add`,
    // 会社情報詳細を取得する
    getCompanyDetail: `/${companyAddToolEnterPoint}/company/detail`,
    // 会社情報編集
    updateCompanyInfo: `/${companyAddToolEnterPoint}/company/update`,
    // 会社情報オプション設定
    setConnectOptionInfo: `/${companyAddToolEnterPoint}/company/option/set`,
    // 会社情報削除
    deleteCompanyInfo: `/${companyAddToolEnterPoint}/company/delete`,

    // 会社情報汎用定義を取得する
    getCompanyGeneralData: `/${companyAddToolEnterPoint}/company/general`,
    // ユーザ一覧を取得する
    getUserInfoListData: `/${companyAddToolEnterPoint}/company/user/list`,
    // ユーザ新規登録
    addUserInfo: `/${companyAddToolEnterPoint}/company/user/add`,
    // ユーザ編集
    updateUserInfo: `/${companyAddToolEnterPoint}/company/user/update`,
    // ユーザ削除
    deleteUserInfo: `/${companyAddToolEnterPoint}/company/user/delete`,

    // お知らせ一覧を取得する
    getAnnouncementListData: `/${companyAddToolEnterPoint}/company/announce/list`,
    // ログイン通知の取得する
    getAnnouncementLoginListData: `/${companyAddToolEnterPoint}/company/announce/login/list`,
    // お知らせ新規登録
    addAnnounce: `/${companyAddToolEnterPoint}/company/announce/add`,
    // お知らせ編集
    updateAnnounce: `/${companyAddToolEnterPoint}/company/announce/update`,

    // 管理対象一覧を取得する
    getManagementTargetListData: `/${companyAddToolEnterPoint}/company/management/target/list`,

    // CSVアップロード
    uploadToolCSV: `/${companyAddToolEnterPoint}/company/csv/upload`,
    // 会社登録ユーザ一覧を取得する
    getManagementUserInfoListData: `/${companyAddToolEnterPoint}/company/admin/list`,
    // 会社登録ユーザ新規登録
    addManagementUserInfo: `/${companyAddToolEnterPoint}/company/admin`,
    // 会社登録ユーザ編集
    updateManagementUserInfo: `/${companyAddToolEnterPoint}/company/admin/update`,
    // 会社登録ユーザ削除
    deleteManagementUserInfo: `/${companyAddToolEnterPoint}/company/admin/delete`,
    // MFA認証リセット
    mfaReset: `/${companyAddToolEnterPoint}/company/admin/mfa/reset`,
    // データ復旧を取得する
    getToolDataRecoverData: `/${companyAddToolEnterPoint}/company/data/recovery/history/list`,
    // データ復旧実行
    postDataRecovery: `/${companyAddToolEnterPoint}/company/data/recovery`,
    // 端末一覧
    getSigfoxInfoListData: `/${companyAddToolEnterPoint}/company/sigfox/list`
  },
  /**
   * 画面メニュー
   */
  menu: {
    login: '/login',
    home: `/MAP`, // 動態地図
    dynamicMap: `/MAP`, // 動態地図
    locusDisplay: `/MAP_LOCUS`, // 軌跡表示
    managementList: `/MGMT_TRGTS`, // 管理対象一覧
    alarmList: `/ALARM`, // アラーム一覧
    historyManagement: `/OP_PERF_MVMT`, // 移動履歴管理表
    analysisByBusinessOffices: `/OP_PERF_OFC`, // 営業所別分析
    areaAnalysis: `/OP_PERF_AREA`, // エリア別分析
    chartArea: `/CHART_AREA`, // グラフ表示(エリア別)
    chartPrefecture: `/CHART_PREFECTURE`, // グラフ表示(都道府県別)
    analysisByManagementObject: `/OP_PERF_TRGTS`, // 管理対象分析
    subjectMaster: `/MST_MGMT_TRGTS`, // 管理対象マスタ
    subjectMasterAllocation: `/MST_MGMT_TRGTS_ALLOC`, // 管理対象割当
    tractorHeadMaster: `/MST_AVL_TRACTOR_HEAD`, // 連結可能トラクターヘッドマスタ
    headMaster: `/MST_TRACTOR_HEAD`, // トラクターヘッドマスタ
    gpsTrackeraster: `/MST_GPS_TRACKER`, // GPSトラッカーマスタ
    managementLocationMaster: `/MST_MGMT_LOC`, // 管理場所マスタ
    managementLocationDetailMaster: `/MST_MGMT_LOC_DTLS`, // 管理場所詳細マスタ
    businessOfficeMaster: `/MST_SALES_OFC`, // 営業所マスタ
    businessOfficeAllocation: `/MST_SALES_OFC_ALLOC`, // 営業所割当
    userMaster: `/MST_USER`, // ユーザマスタ
    areaMaster: `/MST_AREA`, // エリアマスタ
    areaAllocation: `/MST_PREF_ALLOC`, // エリア割当
    gpsTrackerTerminalConfig: `/MST_GPS_TRK_SET`, // GPSトラッカー端末判定値設定
    corporateManagement: `/MST_CO_MGMT`, // 会社管理
    alertList: `/ALERT_LIST`, // アラートリスト
    gpsTrackerExchange: '/MST_GPS_TRK_EXCHANGE', //バッテリー交換
    connectCompanyMaster: '/MST_CONNECT_COMPANY' // 連携会社マスタ
  },
  toolMenu: {
    companyHome: `/TOOL_COMPANY_MASTER`, // 会社情報一覧
    companyInfo: `/TOOL_COMPANY_MASTER`, // 会社情報一覧
    companyInfoAddEdit: `/TOOL_COMPANY_ADD_EDIT`, // 会社情報新規登録、編集
    companyInfoOpSet: `/TOOL_COMPANY_OPTION_SET`, // オプション機能設定
    userInfo: `/TOOL_USER_INFO`, // ユーザ情報一覧
    announcementInfo: `/TOOL_ANNOUNCEMENTS_INFO`, // お知らせ
    companyManagementTarget: `/TOOL_MANAGEMENT_TARGET_MASTER`, // 管理対象一覧
    companyManagementRegister: '/TOOL_MANAGEMENT_REGISTER', // 会社登録ユーザ一覧
    companyDataRecovery: '/TOOL_DATA_RECOVERY', // データ復旧
    companySigfoxInfo: '/TOOL_SIGFOX_INFO' // 端末情報
  }
}

export default config
